import { Component, Directive, EventEmitter, Input, Output, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { Question } from 'src/app/core-module/models/Audits/question';
import { formatLocalDateAnswer, parseLocalDateAnswer } from 'src/app/core-module/models/Utils/local-date-answer';
@Directive({
    selector: '[hash]',
    standalone: false
})
export class HashDirective {
  @Input() hash: string;
  constructor(public vcRef: ViewContainerRef) { }
}

@Component({
    selector: 'app-date-time',
    templateUrl: './date-time.component.html',
    styleUrls: ['./date-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateTimeComponent {
  public selectedDate: Date | null = null;
  public selectedTime: Date | null = null;
  public selectedCalendarDate: Date | null = null;

  @Input() width: string = '1/5';

  @Input() currentQuestion: Question;
  @Output() currentQuestionChange = new EventEmitter<Question>();


  ngOnChanges() {

    this.validateIncomingDate(this.currentQuestion.CompletionInfo.Answer);

  }
  ngAfterViewInit() {

  }
  validateIncomingDate(value: Date | string | null) {
    const incomingDate = parseLocalDateAnswer(value);
    this.selectedDate = incomingDate ? new Date(incomingDate.getTime()) : null;
    this.selectedTime = incomingDate ? new Date(incomingDate.getTime()) : null;
    this.selectedCalendarDate = incomingDate ? new Date(incomingDate.getTime()) : null;
  }
  setCurrentLocalDateTime() {
    const now = new Date();
    this.selectedCalendarDate = new Date(now.getTime());
    this.selectedTime = new Date(now.getTime());
    this.updateCurrentDate();
  }
  updateCurrentDate() {
    if (!this.selectedCalendarDate || !this.selectedTime) {
      this.selectedDate = null;
      this.currentQuestion.CompletionInfo.Answer = null;
      this.currentQuestion.CompletionInfo.QuestionAnswered = false;
      this.currentQuestionChange.emit(this.currentQuestion);
      return;
    }

    this.selectedDate = new Date(
      this.selectedCalendarDate.getFullYear(),
      this.selectedCalendarDate.getMonth(),
      this.selectedCalendarDate.getDate(),
      this.selectedTime.getHours(),
      this.selectedTime.getMinutes(),
      this.selectedTime.getSeconds()
    );
    this.currentQuestion.CompletionInfo.Answer = formatLocalDateAnswer(this.selectedDate, true);
    this.currentQuestion.CompletionInfo.QuestionAnswered = true;
    this.currentQuestionChange.emit(this.currentQuestion);
  }

}


